import { Updater, SortingState } from '@tanstack/react-table';

export function handleTableSortingChange(
  updaterOrValue: Updater<SortingState>,
  currentSorting: SortingState,
): SortingState {
  let newSorting: SortingState;
  if (typeof updaterOrValue === 'function') {
    newSorting = updaterOrValue(currentSorting);
  } else {
    newSorting = updaterOrValue;
  }

  // Ensure only one column is sorted at a time
  if (newSorting.length > 0) {
    // Get the last sorted column (the one that was just toggled)
    const activeSort = newSorting[newSorting.length - 1];
    return [activeSort];
  } else if (currentSorting.length > 0) {
    // An empty sort means TanStack wants to remove the sort. Flip the direction instead, otherwise
    // a column with a `null` first value gets stuck.
    const previousColumn = currentSorting[0];
    return [{ id: previousColumn.id, desc: !previousColumn.desc }];
  } else {
    return [];
  }
}

export const accumulateCaseRefs = (chats: { caseRef?: string }[], prev: Set<string>): Set<string> => {
  const next = new Set(prev);
  chats.forEach((chat) => {
    if (chat.caseRef?.trim()) {
      next.add(chat.caseRef);
    }
  });
  return next;
};
